export enum GeneralTexts {
    DATA = 'data',
    DOCUMENTS = 'documents',
    PRODUCT_ICON = 'productIcon',
    MANUFACTURER_ICON = 'manufacturerIcon',
}